import { render, staticRenderFns } from "./tbEdit.vue?vue&type=template&id=e59db4d8&scoped=true&"
import script from "./tbEdit.vue?vue&type=script&lang=js&"
export * from "./tbEdit.vue?vue&type=script&lang=js&"
import style0 from "./tbEdit.vue?vue&type=style&index=0&id=e59db4d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59db4d8",
  null
  
)

export default component.exports